import React, { useState } from "react";
import { Collapse, IconButton, Box, Typography, Grid } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

const categoryGuide = [
  {
    name: "Base",
    purpose: "Core structural ingredients used in the batter or dough",
    examples: "Flour, Sugar, Cornstarch, Baking Powder",
  },
  {
    name: "Dairy & Eggs",
    purpose: "Milk-based or chilled ingredients",
    examples: "Butter, Cream, Yogurt, Eggs",
  },
  {
    name: "Flavor",
    purpose: "Used to add flavor, not structure",
    examples: "Cocoa Powder, Vanilla, Coffee, Citrus Zest",
  },
  {
    name: "Filling",
    purpose: "Goes between layers or inside the product",
    examples: "Curd, Jam, Ganache, Mousse",
  },
  {
    name: "Frosting & Cream",
    purpose: "Used to cover, pipe, or top the cake",
    examples: "Buttercream, Mascarpone, Whipped Cream",
  },
  {
    name: "Topping & Garnish",
    purpose: "Final-layer edible decoration",
    examples: "Nuts, Fresh Fruit, Drizzle, Chocolate Shavings",
  },
  {
    name: "Decoration",
    purpose: "Design-focused elements (edible or non-edible)",
    examples: "Fondant, Sugar Pearls, Macarons, Toppers",
  },
  {
    name: "Coloring & Effects",
    purpose: "Visual enhancement without flavor",
    examples: "Gel Color, Lustre Dust, Edible Glitter",
  },
  {
    name: "Packaging",
    purpose: "Used to pack or present the product",
    examples: "Cake Boards, Boxes, Wraps",
  },
];

const IngredientCategoryGuide = () => {
  const [open, setOpen] = useState(false);

  return (
    <Box sx={{ mb: 2 }}>
      <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
        <IconButton onClick={() => setOpen((prev) => !prev)} size="small">
          <InfoOutlinedIcon />
        </IconButton>
        <Typography variant="body2" sx={{ ml: 1 }}>
          Unsure about category? Click to view guide.
        </Typography>
      </Box>

      <Collapse in={open}>
        <Box
          sx={{
            border: "1px solid #C8E6C9",
            borderRadius: 2,
            backgroundColor: "#F1F8E9",
            p: 2,
          }}>
          <Grid
            container
            spacing={1}
            sx={{
              fontSize: 14,
              color: "#2E7D32",
              boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
            }}>
            <Grid item xs={4}>
              <strong>Category</strong>
            </Grid>
            <Grid item xs={4}>
              <strong>What Goes Here</strong>
            </Grid>
            <Grid item xs={4}>
              <strong>Examples</strong>
            </Grid>

            {categoryGuide.map((row, idx) => (
              <React.Fragment key={idx}>
                <Grid item xs={4}>
                  {row.name}
                </Grid>
                <Grid item xs={4}>
                  {row.purpose}
                </Grid>
                <Grid item xs={4}>
                  {row.examples}
                </Grid>
              </React.Fragment>
            ))}
          </Grid>
        </Box>
      </Collapse>
    </Box>
  );
};

export default IngredientCategoryGuide;
